export default __webpack_public_path__ + "static/media/gu.7eb2cd3b.png";